import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AssignmentsApi } from './assignments.api';
import { BuildingApi } from './building.api';
import { CommentApi } from './comment.api';
import { CustomFormBuilderApi } from './custom-form-builder/custom-form-builder.api';
import { FileApi } from './file.api';
import { MessagingApi } from './messaging/messaging.api';
import { ObservationListApi } from './observation-list.api';
import { AnecdotalApi } from './observations/anecdotal.api';
import { CustomFormsApi } from './observations/custom-forms/custom-forms.api';
import { DiffApi } from './observations/diff.api';
import { FormalApi } from './observations/formal/formal.api';
import { NtpeApi } from './observations/ntpe.api';
import { RatingFormApi } from './observations/ratingform-api';
import { RubricApi } from './observations/rubric/rubric.api';
import { SpmApi } from './observations/spm.api';
import { PaetepPortalApi } from './paetep-portal.api';
import { PaetepUserApi } from './paetep-user.api';
import { PermissionsApi } from './permissions/permissions.api';
import { ResourceApi } from './resource.api';
import { SignatureApi } from './signatures.api';
import { SloApi } from './slo.api';
import { SupervisionManagementApi } from './supervision-management.api';
import { WalkthroughApi } from './walkthrough.api';
import { ReportingApi } from './reporting/reporting.api';
import { ContentApi } from './content.api';
import { PresetManagementAPI } from './preset-management.api';
import { OnboardingApi } from './onboarding.api';

@NgModule({
    imports: [
        CommonModule
    ],
    providers: [
        AnecdotalApi,
        AssignmentsApi,
        BuildingApi,
        CommentApi,
        CustomFormsApi,
        CustomFormBuilderApi,
        DiffApi,
        FileApi,
        FormalApi,
        MessagingApi,
        NtpeApi,
        ObservationListApi,
        PaetepPortalApi,
        PaetepUserApi,
        PermissionsApi,
        PresetManagementAPI,
        RatingFormApi,
        ReportingApi,
        ResourceApi,
        RubricApi,
        SignatureApi,
        SloApi,
        SpmApi,
        SupervisionManagementApi,
        WalkthroughApi,
        ContentApi,
        OnboardingApi
    ]
})
export class ApiModule { }
